import moment from 'moment';

const getUpdatedSelectedDate = (
  selectedDate: string | null | undefined,
  firstAvailableScheduledDate: string | undefined,
  waitlist: { mode: string } | null | undefined,
): string | null | undefined => {
  if (!selectedDate || !firstAvailableScheduledDate) {
    return selectedDate;
  }

  const setFirstAvailableDate = waitlist ? waitlist.mode === 'NONE' : true;

  const isValidFirstAvailableDate =
    setFirstAvailableDate &&
    moment(firstAvailableScheduledDate).isAfter(selectedDate);

  return isValidFirstAvailableDate ? firstAvailableScheduledDate : selectedDate;
};

export default getUpdatedSelectedDate;
